export const TechnologyIntelligenceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="currentColor"
    viewBox="0 0 256 256"
  >
    <path d="M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-143.79-4.73,71.64,71.64,0,0,0,27.4,62.31A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.53-25.31A71.62,71.62,0,0,0,200,104Zm-66.33-40a8,8,0,0,0-10.64-3.77l-32,16a8,8,0,1,0,7.18,14.31l32-16A8,8,0,0,0,133.67,64ZM192,120a8,8,0,0,0-8-8H152a8,8,0,0,0,0,16h32A8,8,0,0,0,192,120ZM82.67,76.24a8,8,0,0,0,10.66-3.77A8,8,0,0,0,89.56,61.8l-32-16A8,8,0,0,0,50.33,59.47Z"></path>
  </svg>
);
